import '../../../styles/forms.css.js';
import 'bootstrap/dist/css/bootstrap.css';
import React__default from 'react';
import Stack from '../../DataDisplay/Stack/Stack.js';
import '../../DataDisplay/Table/Table.js';
import '../../DataDisplay/TextTruncate/TextTruncate.module.css.js';
import '../../../styles/fonts.css.js';
import 'classnames';
import '../../Layout/Tooltip/Tooltip.js';
import '../Button/Button.module.scss.js';

const RadioGroup = ({ id, children, orientation = 'column', gap = 10, onChange, }) => {
    const renderChildrenWithProps = () => {
        return React__default.Children.map(children, child => {
            if (React__default.isValidElement(child)) {
                return (React__default.createElement("div", { key: child.props.id }, React__default.cloneElement(child, {
                    id,
                    onChange,
                })));
            }
            return null;
        });
    };
    return (React__default.createElement("div", { id: id },
        React__default.createElement(Stack, { direction: orientation, gap: gap }, renderChildrenWithProps())));
};

export { RadioGroup as default };
//# sourceMappingURL=RadioGroup.js.map
